<template>
  <v-dialog
    content-class="safetyStViewWrapper"
    :value="true"
    fullscreen
    hide-overlay
    persistent
  >
    <div class="safetyStView">
      <div class="safetyStView_header">
        <span>View statements</span>
        <button type="button" @click="closeDialog">
          <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
        </button>
      </div>
      <div class="safetyStView_top">
        Employee: <span class="spanText">{{ safetyStatementsView.employee }}</span> |
        Period: <span class="spanText">{{ getPeriod }}</span>
      </div>
      <main-table
        v-if="safetyStatementsView"
        :headers="getHeader"
        :listItems="safetyStatementsView.rows"
        flag="safety-st-view"
        :is-create="false"
        :is-search="false"
        :is-filter-refresh="false"
        :is-export="false"
      ></main-table>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { safetyStatementsViewHeader } from "@/pages/Accounting/SafetyStatements/constants";

export default {
	name: "SafetyStatementsView",
	props: {
		month: String,
	},
	computed: {
		...mapGetters([ 'safetyStatementsView' ]),
		getHeader() {
			return safetyStatementsViewHeader;
		},

		getPeriod() {
			return this.safetyStatementsView.period.length > 0 ? this.safetyStatementsView.period : this.month;
		}
	},
	methods: {
		closeDialog() {
			this.$emit('updateCloseViewDialog');
		}
	}
};
</script>

<style scoped lang="scss">
.safetyStView {
  min-height: 100vh;
  background: #22222d;
  padding: 20px;
  
  .spanText {
    color: #19BC38;
    padding: 0 10px;
  }
  
  &_top {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    
    &-fl {
      display: flex;
      align-items: center;
    }
  }
  
  &_body {
    margin-bottom: 20px;
  }
  
  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.25px;
    text-align: left;
  }
}
</style>
